export default "__VITE_ASSET__DVAsEsW4__"